export const defaultIsTeammateWorkspaceExpanded = true;
export const defaultIsTeammateWorkspaceInboxExpanded = true;
